import Icon from '../../../widgets/Icons';
import * as React from 'react';
import { ScoreOutOf } from '../../dashboard/SecurityReadiness';
import { Progress } from 'reactstrap';
import { useSelector } from 'react-redux';
import { memoizedOnboardingCompletionSelectors } from '../../../selectors/onboardingCompletionSelectors';

export const OnboardingProgress = () => {
  const { totalSections, completedSections } = useSelector(
    memoizedOnboardingCompletionSelectors.getCompletionStatus,
  );

  return (
    <>
      <div style={{ gridArea: 'score', display: 'flex' }}>
        <Icon.UnorderedList
          style={{
            width: '35px',
            height: '35px',
            fill: '#58595B',
            paddingRight: '10px',
          }}
        />
        <ScoreOutOf score={completedSections} outOf={totalSections} />
      </div>
      <Progress
        style={{ gridArea: 'progress', width: '600px' }}
        color="success"
        value={(completedSections / totalSections) * 100}
      />
    </>
  );
};
